import moment from "moment/moment";

export const useDashboardUnitKey = (date, numberOfUnits) => {
    return Object.keys(numberOfUnits || {}).find(element => {
        if (moment(date).format('YYYY-MM-DD') === element) {
            return numberOfUnits[element];
        }
        return false
    });
}



// WEBPACK FOOTER //
// ./src/containers/Layouts/CustomHooks/useDashboardUnitKey.js